import { Loan } from '@nemuru-eng/js-api-client';
import { PricingFromCdn } from '@nemuru-eng/js-api-client/slim';

import { PricingFilterType } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/types/PricingFilterType';

export const ChangeLoanConditions = {
  getPricingById: (pricings: PricingFromCdn[], pricingId: string): PricingFromCdn | undefined => {
    return pricings.find((pricing) => pricing.id === pricingId);
  },
  getPricingsSelectOptions: (
    pricings: PricingFromCdn[],
    loan: Loan,
    keys: PricingFilterType[] = [],
  ): PricingFromCdn[] => {
    if (!pricings || pricings.length === 0) return [];

    const formattedLoanConditions = {
      [PricingFilterType.PRODUCT]: loan.loanConditions.product,
      [PricingFilterType.PROGRAM]: loan.loanConditions.program.name,
    };

    const filteredPricings =
      keys.length === 0
        ? pricings
        : pricings.filter((pricing) =>
            keys.every((key) => pricing[key] && pricing[key] === formattedLoanConditions[key]),
          );

    return filteredPricings;
  },
  isTermWithinRange: (pricing: PricingFromCdn, term: number): boolean => {
    return pricing.rangePeriodMin <= term && pricing.rangePeriodMax >= term && pricing.rangePeriodMin !== 0;
  },
};
